import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import SyncConstants from "../../constants/SyncConstants";
import { copy } from "../../libs/SlotUtils";
import ExpenseEntryList from "./ExpenseEntryList";
import stylelist from "stylelist";

const MinutesToTime = (props) => {
    return <>
        {(props.minutes / 60 + props.minutes % 60) < 0 && "-"}
        {Math.floor(Math.abs(props.minutes / 60)).toString().padStart(2,"0")}:{(Math.abs(props.minutes % 60)).toString().padStart(2,"0")}
    </>
}

export default MinutesToTime;